module.exports = __webpack_public_path__ + "static/img/securities_back.9384c67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/securities_back.jpg?20181011
// module id = A1CJ
// module chunks = 1